import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {VisitSummaryPDF} from "./VisitSummaryPDF";
import * as Yup from "yup";
import RecommendedTreatments from "../../../components/PatientOnboard/RecommendedTreatments";
import FormElementContainer from "../../../components/forms_builder/FormElementContainer";
import VisitSummaryFirstBlock from "../../../components/PatientOnboard/VisitSummaryFirstBlock";
import VisitSummarySecondBlock from "../../../components/PatientOnboard/VisitSummarySecondBlock";
import {authenticationService} from "../../../services/AuthenticationService";
import doctorApi from "../../../services/ApiServices/doctorApi";

const validationSchema = Yup.object().shape({
    /*
        visit_summary:Yup.string().nullable().required(t('patient_boarding.field_mandatory')),
    */

})

class VisitSummaryTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            symptoms: this.props.symptoms,
            entry: this.props.entry,
            checkboxes: this.props.checkboxes,
            medications: this.props.medications,
            medical_diagnose_icd: this.props.medical_diagnose_icd,
            medicationsList: this.props.medicationsList,
            patientTreatments: this.props.patientTreatments,
            patient_allergics: this.props.patient_allergics,
            clinicPhoto: "",
            pdfLoading: false,

        };
    }

    addOtherMedicalDiagnosis() {
        this.props.onclickSetIsOtherMedicalDiagnosis()
    }

    deleteOtherMedicalDiagnosis() {
        this.props.onValueChange("Another_Medical_diagnoses_icd_name", "")
        this.props.onValueChange("Another_Medical_diagnoses_icd_code", "")
        this.props.onValueChange("another_other_diagnoses", "")
        this.props.onclickSetIsOtherMedicalDiagnosis()
    }

    onChangeDiagnoseCode(value, name, code) {
        this.props.onValueChange(name, value)
        let {medical_diagnose_icd} = this.state
        let isUpdated = 0
        let otherVariable
        for (let i = 0; i < medical_diagnose_icd.length; i++) {
            let diagnose = medical_diagnose_icd[i]
            if (diagnose.ICD_diagnosis_id === 155) {
                otherVariable = {value: diagnose.ICD_diagnosis_id, label: diagnose.Diagnosis_description}
            }
            if (diagnose.Diagnosis_code === value) {
                this.props.onValueChange(code, {value: diagnose.Diagnosis_code, label: diagnose.Diagnosis_description})
                isUpdated += 1
            }
        }
        if (isUpdated === 0) {
            this.props.onValueChange(code, otherVariable)
        }
    }

    onChangeDiagnose(option, name, code, another) {
        let {medical_diagnose_icd} = this.state
        this.props.onValueChange(name, option)
        if (option.value === 155) {
            this.props.onValueChange(code, "")
        } else {
            this.props.onValueChange(another, "")
            for (let i = 0; i < medical_diagnose_icd.length; i++) {
                let diagnose = medical_diagnose_icd[i]
                if (diagnose.Diagnosis_description === option.label) {
                    this.props.onValueChange(code, diagnose.Diagnosis_code)
                }
            }
        }
    }

    handleMedicalDiagnoseChange(option) {
        this.onChangeDiagnose(option, "medical_diagnoses_icd_name", "medical_diagnoses_icd_code", "other_diagnoses")
    }

    onChangeNextVisitDocChange(option) {
        this.props.onChangeNextVisitDocChange(option)
    }

    handleAnotherMedicalDiagnoseChange(option) {
        this.onChangeDiagnose(option, "Another_Medical_diagnoses_icd_name", "Another_Medical_diagnoses_icd_code", "another_other_diagnoses")
    }


    componentWillMount() {
        this.props.initValidation(validationSchema)
    }

    async componentDidMount() {
        let {
            entry,
            symptoms,
            medications,
            patientTreatments,
            medicationsList,
            patient_allergics,
            checkboxes
        } = this.state
        let clinicPhoto = await doctorApi.getClinicProfilePic()
        clinicPhoto = clinicPhoto ? clinicPhoto.data : ""

        let doctorProfile
        if (entry.Prescribing_MD) {
            doctorProfile = await doctorApi.getHCPById(entry.Prescribing_MD)
            doctorProfile = doctorProfile ? doctorProfile.data : ""
        }


        entry['symptoms'] = symptoms
        entry['medications'] = medications
        entry['patient_allergics'] = patient_allergics.map(item => {
            return item.label
        })

        let treatments = patientTreatments

        for (let i = 0; i < treatments.length; i++) {
            treatments[i].symptomsArr = []
            let treatmentSymptoms = treatments[i] ? treatments[i].Symptom_ID : []
            if (treatmentSymptoms) {
                for (let b = 0; b < treatmentSymptoms.length; b++) {
                    let desc = this.props.motherClass.getSymptomsDesc(treatmentSymptoms[b].toString(), "he")
                    treatments[i].symptomsArr.push(desc)
                }
            }
        }

        let currentUserProfile = authenticationService.currentUserValue.profile;
        let clinicName = currentUserProfile.Doctor?.Clinic?.Clinic_Name ? currentUserProfile.Doctor.Clinic.Clinic_Name : ""

        let doctorName = !clinicName.includes("נטע") ? "ד\"ר " : ""
        let firstName = doctorProfile?.PII?.First_name ? doctorProfile.PII.First_name : ""
        let lastName = doctorProfile?.PII?.Last_name ? doctorProfile.PII.Last_name : ""
        doctorName = doctorName + firstName + " " + lastName

        entry.doctorProfile = doctorProfile

        entry.doctorName = doctorName
        entry.doctorSignature = doctorProfile?.Signature
        entry.patientTreatments = treatments
        entry.medicationsList = medicationsList
        entry.clinicPhoto = clinicPhoto
        entry.painText = this.getMedicationInfo(this.props.currentPain_medications)
        let takeBloodThinner = ""
        takeBloodThinner = entry.take_bloodThinning === "No" ? "לא" : takeBloodThinner
        takeBloodThinner = entry.take_bloodThinning === "Unknown" ? "לא ידוע" : takeBloodThinner
        entry.bloodThinnerText = this.getMedicationInfo(this.props.bloodThinner_medications)
        entry.bloodThinnerText = entry.bloodThinnerText ? entry.bloodThinnerText : takeBloodThinner
        entry.generalMedicationsText = this.getMedicationInfo(this.props.general_medications)
        entry.pastMedText = this.getArrayLabel(this.props.past_med, "label", "PastUseOtherMed")
        entry.allergicsText = this.getArrayLabel(this.props.patient_allergics, "value", "OtherAllergics")
        entry.medConditionText = this.getArrayLabel(this.props.medicalConditionsSelected, "value", "OtherMedicalCondition")
        entry.SymptomsText = this.getArrayLabel(this.props.symptoms, "Symptom_description", "OtherSymptom")
        let instructionText = []
        let nextVisitDocSelected = this.props.nextVisitDocSelected
        for (let i = 0; i < nextVisitDocSelected.length; i++) {
            instructionText.push(this.getDocInstruction(nextVisitDocSelected[i].value))
        }

        entry.instructionText = instructionText

        entry = {...entry, ...checkboxes}


        this.setState({entry, clinicPhoto: clinicPhoto})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== this.state.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }


    async showFile() {
        let {entry} = this.state
        let visitSummary = new VisitSummaryPDF(entry)
        let myWindow = window.open("", "MsgWindow", "width=1010, height=1500");
        myWindow.document.innerHTML = '';
        let checkElement = myWindow.document.getElementById("pdf-Body")
        if (checkElement) {
            myWindow.document.getElementById("pdf-Body").innerHTML = "";
        }
        let html = visitSummary.initHTML()
        myWindow.document.write(html);
    }

    async exportFile() {
        this.setState({pdfLoading: true})
        let {entry} = this.state
        let visitSummary = new VisitSummaryPDF(entry)
        let html = visitSummary.initHTML()
        html = html.replaceAll("\"", '\'')

        let obj = {
            "html": html,
            "inline": true,
            "fileName": entry.UserStorageID + "-VisitSummary",
            "options": {
                "displayHeaderFooter": true,
                "orientation": "Portrait",
                "pageSize": "A4",
                "footerTemplate": "<div class=\"page-footer\" style=\"width:100%; font-size:8px; color: #1d1d1b;font-family: Assistant, sans-serif; font-weight: 300;text-align:center;\"> <span class=\"pageNumber\"></span>/<span class=\"totalPages\"></span></div>"
            },
            "enableToc": false,
            "tocOptions": {
                "tocHeaderText": "Lorem Ipsum",
                "tocLevelIndentation": "1em"
            },
            "useCustomStorage": false,
            "storage": {
                "method": "PUT",
                "url": "https://presignedurl",
                "extraHTTPHeaders": {}
            }
        }

        let response = await doctorApi.generatePDFAPI(obj)
        let doc = ""

        if (response) {
            doc = response.data.FileUrl
            let pdfSaved = await doctorApi.savePdfFile(entry.UserStorageID, entry.RequestID, {url: doc})
            if (pdfSaved) {

                window.open(pdfSaved.data.link, '_blank');
            }
        }
        this.setState({pdfLoading: false})
    }


    onValueChange = (name, value) => {
        this.props.onValueChange(name, value)
    }
    onClickCheckboxes = (name) => {
        this.props.onClickCheckboxes(name)
    }
    onYesNoValueChange = (name, value) => {
        this.props.onYesNoValueChange(name, value)
    }

    getDocInstruction(index) {
        let {nextVisitDoc} = this.props
        for (let i = 0; i < nextVisitDoc.length; i++) {
            if (index === nextVisitDoc[i].index) {
                return nextVisitDoc[i].Instruction
            }
        }
    }


    getMedicationInfo(medArr) {
        let med = ""
        let dosageUnit = ""
        let allText = ""
        for (let i = 0; i < medArr.length; i++) {
            let Dosage_mg_day = medArr[i].Dosage_mg_day ? medArr[i].Dosage_mg_day : ""
            let unit = medArr[i].Dosage_unit ? medArr[i].Dosage_unit : "mg"
            med = medArr[i].Medication_name ? medArr[i].Medication_name : ""
            if (med === "Other" || med === "אחר") {
                med = medArr[i].OtherMed ? medArr[i].OtherMed : ""
            }
            dosageUnit = Dosage_mg_day ? Dosage_mg_day + unit : ""
            if (i !== medArr.length - 1) {
                allText = allText + med + " " + dosageUnit + ", "
            } else {
                allText = allText + med + " " + dosageUnit
            }
        }
        return allText
    }

    getArrayLabel(givenArray, obj, otherObj) {
        let result = ""
        let {entry} = this.state
        for (let i = 0; i < givenArray.length; i++) {
            let text = givenArray[i][obj] ? givenArray[i][obj] : ""
            if (otherObj.includes("MedicalCondition")) {
                text = this.props.getConditionDesc(text, "he")
            } else if (otherObj.includes("Allergics")) {
                text = this.props.getAllergicDesc(text, "he")
            }
            if (text === "Other" || text === "אחר") {
                text = entry[otherObj] ? entry[otherObj] : ""
            }
            if (text) {
                if (obj === "Symptom_description") {
                    text = this.props.motherClass.getSymptomsDesc(givenArray[i]["Symptom_ID"].toString().substring(1), "he")
                }
                result = result !== "" ? result + ", " + text : text

            }
        }
        return result
    }


    render() {

        let {symptomsArr, entry, medical_diagnose_icd} = this.state
        let {t} = this.props

        let next_date = ""

        if (entry.next_visit_date) {
            next_date = new Date(entry.next_visit_date)
        }

        if (this.state.pdfLoading) {
            return <div className="loader"/>
        }

        return (
            <div className={'patientForm-box-container'} id={"test-pdf-id"}>

                <label className={'patientsFormBoxes-title-text-label-visitSummary'}>
                    {t('patient_boarding.visit_summury')}
                </label>

                <FormElementContainer title={''}
                                      Component={VisitSummaryFirstBlock}
                                      rest={{
                                          onValueChange: (name, value) => this.onValueChange(name, value),
                                          handleMedicalDiagnoseChange: (option) => this.handleMedicalDiagnoseChange(option),
                                          handleAnotherMedicalDiagnoseChange: (option) => this.handleAnotherMedicalDiagnoseChange(option),
                                          onChangeDiagnoseCode: (value, name, code) => this.onChangeDiagnoseCode(value, name, code),
                                          addOtherMedicalDiagnosis: () => this.addOtherMedicalDiagnosis(),
                                          deleteOtherMedicalDiagnosis: () => this.deleteOtherMedicalDiagnosis(),
                                          entry: this.props.entry,
                                          isOtherPsychiatricDiagnosis: this.props.isOtherPsychiatricDiagnosis,
                                          medical_diagnose_icd: this.props.medical_diagnose_icd,
                                          errors: this.props.errors,
                                          t: (e) => this.props.t(e)
                                      }}/>

                <FormElementContainer title={t('patient_boarding.Recommended_Treatments')}
                                      Component={RecommendedTreatments}
                                      rest={{
                                          onValueChange: (name, value) => this.onValueChange(name, value),
                                          entry: this.props.entry,
                                          errors: this.props.errors,
                                          t: (e) => this.props.t(e)
                                      }}/>

                <FormElementContainer title={''}
                                      Component={VisitSummarySecondBlock}
                                      rest={{
                                          onValueChange: (name, value) => this.onValueChange(name, value),
                                          onClickCheckboxes: (name) => this.onClickCheckboxes(name),
                                          onChangeNextVisitDocChange: (option) => this.onChangeNextVisitDocChange(option),
                                          entry: this.props.entry,
                                          errors: this.props.errors,
                                          nextVisitDoc: this.props.nextVisitDoc,
                                          nextVisitDocSelected: this.props.nextVisitDocSelected,
                                          t: (e) => this.props.t(e)
                                      }}/>


                {/*    <div className={'patientsFormBoxes'}>
                    <div className={'patientsFormRow'}>
                        <div className={'inputSlotsBlock'}>
                            <label className={'infoLabel'}>{t('patient_boarding.next_visit')}:</label>
                            <DatePicker
                                className={'inputBoxStyle-medium'}
                                showYearDropdown={true} showMonthDropdown={true}
                                dateFormat="dd/MM/yyyy"
                                selected={next_date}
                                minDate={new Date()}
                                onChange={(event) => this.props.onValueChange("next_visit_date", event)}/>
                        </div>
                    </div>

                </div>*/}


                <div className={'patientsFormRow'}>

                    <button className={'view-visit-summary-button'}
                            onClick={() => this.showFile()}>{t('patient_boarding.view_summary_report')}</button>
                    <button className={'view-visit-summary-button'}
                            onClick={() => this.exportFile()}>{t('patient_boarding.view_summary_PDF')}</button>
                </div>
                <div className={'blankSpace'}/>


            </div>
        );
    }
}


const VisitSummaryTab = compose(
    withTranslation(),
    /*connect(
        mapStateToProps,
        mapDispatchToProps
    )*/
)(VisitSummaryTabComposed);

export default VisitSummaryTab;

